export default function TextTwoValues(params) {
  const {
    value,
    otherFields,
    data
  } = params;
  const textCell = document.createElement('div');
  textCell.classList.add('w5-text-cell-two-values');
  const secondValue = data[otherFields === null || otherFields === void 0 ? void 0 : otherFields.secondValue] || '';
  if (params.upperCase) textCell.classList.add('w5-text-cell-two-values--upercase');
  const valueLeft = document.createElement('div');
  valueLeft.classList.add('w5-text-cell-two-values--left');
  valueLeft.innerText = value || '-';
  const valueRight = document.createElement('div');
  valueRight.classList.add('w5-text-cell-two-values--right');
  valueRight.innerText = secondValue || '-';
  textCell.appendChild(valueLeft);
  textCell.appendChild(valueRight);
  return textCell;
}